import { useState } from 'react';
import { TFunction, useTranslation } from 'react-i18next';
import { AlertInfo } from '../../../components/AlertInfo';
import Select, { OptionProps } from '../../../components/Select';
import { context } from '../../../utils';
import { ContactUsPurposes } from '../types/ContactUsFormData';

export const SelectPurpose: React.FC<{
    changeAction: (value?: ContactUsPurposes) => void;
}> = ({ changeAction }) => {
    const { t } = useTranslation();
    const [selectedPurpose, setSelectedPurpose] = useState<string>();
    const options: OptionProps<ContactUsPurposes>[] = [
        {
            value: 'identify',
            id: 'identify-option',
            label: t('Identify an implant'),
        },
        {
            value: 'order',
            id: 'order-option',
            label: t('Order components'),
        },
        {
            value: 'partnership',
            id: 'partnership-option',
            label: t('Partnership'),
        },
        {
            value: 'other',
            id: 'other-option',
            label: t('Other (specify)'),
        },
    ];

    const handleChange = (value: ContactUsPurposes | '') => {
        setSelectedPurpose(value);
        changeAction(value === '' ? undefined : value);
    };

    return (
        <div>
            <Select<ContactUsPurposes>
                required
                options={options}
                id={'purpose'}
                label={t('Subject')}
                name={'purpose'}
                onChange={handleChange}
                value={selectedPurpose}
                testId="purpose-selector"
            />
            {getContentByPurpose(selectedPurpose, t)}
        </div>
    );
};

function getContentByPurpose(
    selectedPurpose: string | undefined,
    t: TFunction<'translation', undefined>
) {
    const currentLang = context['current_language'];
    const urls = context['urls'];

    switch (selectedPurpose) {
        case 'identify':
            return (
                <AlertInfo testId="identify-message">
                    <>
                        {t(
                            'For implant identification requests, you can submit your case directly'
                        )}
                        :{' '}
                        <a href={urls['identification']}>
                            {t('Submit a case')}
                        </a>
                    </>
                </AlertInfo>
            );
        case 'order':
            return (
                <AlertInfo testId="order-message">
                    <>
                        {t(
                            'To order components you can browse the marketplace. Please use the form below if you have further questions related to your case: implant model, reference, products needed, etc.'
                        )}{' '}
                        <a href={`/${currentLang}/marketplace/`}>
                            {t('Browse the marketplace')}
                        </a>
                    </>
                </AlertInfo>
            );
        default:
            return <></>;
    }
}
